// MunuHeader.js
import React from "react";
import { Link } from "react-router-dom";
import { ROUTE_BASE_URL } from "../../api/common";
import { useUser } from "../AdminUsers/UserContext";
import { connect } from "react-redux";
import { setOffcanvas } from "../../actions/settingsAction";

function MenuHeader({ setOffcanvas, offcanvas }) {
  const { websiteName, websiteLogo } = useUser();

  return (
    <div className="navbar-brand">
      <Link to={`${ROUTE_BASE_URL}/`}>
        {websiteLogo && <img src={websiteLogo} width={90} alt="Amasi" className="img-fluid logo" />}
        {websiteName && <span>{websiteName}</span>}
      </Link>

      {/* Hamburger Menu for Tablet/Mobile */}
      <button
        type="button"
        className="btn-toggle-offcanvas btn btn-sm float-right d-lg-none"
        onClick={() => setOffcanvas(!offcanvas)}
        aria-label="Toggle sidebar"
      >
        <i className={`fa ${offcanvas ? "fa-times" : "fa-bars"}`}></i>
      </button>
    </div>
  );
}

const mapStateToProps = (state) => ({
  offcanvas: state.settings.offcanvas,
});

const mapDispatchToProps = (dispatch) => ({
  setOffcanvas: (value) => dispatch(setOffcanvas(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MenuHeader);